module.exports = __webpack_public_path__ + "img/card3-bl4.f27b5e83.svg";